import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 12px;

  @media (max-width: 770px) {
    margin-bottom: 20px;
  }
`;

export const MobileBlock = styled.div`
  display: none;

  @media (max-width: 770px) {
    display: block;
    width: 100%;
  }
`;

export const DesktopBlock = styled.div`
  @media (max-width: 770px) {
    display: none;
  }
`;

export const MobileSection = styled.div`
  margin-bottom: 20px;

  h2 {
    margin-bottom: 8px;
  }
`;

export const TitlesContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 12px;
  margin-bottom: 6px;
  width: 95%;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 770px) {
    grid-template-columns: 1fr;
    width: 100%;
    margin-bottom: 8px;
  }
`;

export const SectionTitle = styled.h2`
  font-family: Mangueira, sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  margin: 0;
  text-align: left;
  grid-column: ${(props) => (props.$first ? '1' : '3')};

  @media (max-width: 1200px) {
    grid-column: ${(props) => (props.$first ? '1' : '2')};
  }

  @media (max-width: 770px) {
    grid-column: 1;
  }
`;

/** Texto explicativo ao lado de “Diária” (sem caixa). */
export const DailyMetaHint = styled.p`
  margin: 0;
  padding: 0;
  max-width: 100%;
  font-family: Mangueira, sans-serif;
  font-size: 0.85rem;
  line-height: 1.35;
  font-weight: 400;
  color: #333333;

  @media (max-width: 770px) {
    font-size: 0.8rem;
  }
`;

export const DailyHeadingRow = styled.div`
  grid-column: 3 / span 2;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;

  @media (max-width: 1200px) {
    grid-column: 2 / span 1;
  }
`;

export const DailySectionTitle = styled.h2`
  font-family: Mangueira, sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  margin: 0;
  text-align: left;
  flex-shrink: 0;
`;

export const DailyMobileTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 18px;

  h2 {
    margin-bottom: 0;
  }
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 12px;
  width: 95%;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 770px) {
    grid-template-columns: 1fr;
    gap: 12px;
    width: 100%;
  }
`;
